import React from 'react';
import { Calendar, MapPin, Users, Tag, Clock, Star } from 'lucide-react';

const EventCard = ({ event, onRegister, onViewDetails }) => {
  const availableSpots = event.capacity - event.registered;
  const fillPercentage = (event.registered / event.capacity) * 100;
  
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric', 
      year: 'numeric' 
    });
  };

  return React.createElement('div', { className: `event-card ${event.featured ? 'featured' : ''}` },
    event.featured &&
      React.createElement('div', { className: 'featured-badge' },
        React.createElement(Star, { size: 16 }),
        'Featured'
      ),
    
    React.createElement('div', { className: 'event-image-container' },
      React.createElement('img', { 
        src: event.image, 
        alt: event.title, 
        className: 'event-image' 
      }),
      React.createElement('div', { className: 'event-overlay' },
        React.createElement('span', { className: 'event-category' }, event.category),
        React.createElement('span', { className: 'event-price' }, `$${event.price}`)
      )
    ),
    
    React.createElement('div', { className: 'event-content' },
      React.createElement('h3', { className: 'event-title' }, event.title),
      React.createElement('p', { className: 'event-description' }, event.description),
      
      React.createElement('div', { className: 'event-details' },
        React.createElement('div', { className: 'event-detail' },
          React.createElement(Calendar, { size: 16 }),
          React.createElement('span', null, formatDate(event.date))
        ),
        React.createElement('div', { className: 'event-detail' },
          React.createElement(Clock, { size: 16 }),
          React.createElement('span', null, event.time)
        ),
        React.createElement('div', { className: 'event-detail' },
          React.createElement(MapPin, { size: 16 }),
          React.createElement('span', null, event.location)
        ),
        React.createElement('div', { className: 'event-detail' },
          React.createElement(Users, { size: 16 }),
          React.createElement('span', null, `${event.registered}/${event.capacity} registered`)
        )
      ),
      
      React.createElement('div', { className: 'capacity-bar' },
        React.createElement('div', { 
          className: 'capacity-fill', 
          style: { width: `${fillPercentage}%` } 
        })
      ),
      
      React.createElement('div', { className: 'event-tags' },
        event.tags.slice(0, 3).map((tag, index) =>
          React.createElement('span', { key: index, className: 'event-tag' },
            React.createElement(Tag, { size: 12 }),
            tag
          )
        )
      ),
      
      React.createElement('div', { className: 'event-actions' },
        React.createElement('button', {
          onClick: () => onViewDetails(event),
          className: 'btn-secondary'
        }, 'View Details'),
        React.createElement('button', {
          onClick: () => onRegister(event),
          className: 'btn-primary',
          disabled: availableSpots === 0
        }, availableSpots === 0 ? 'Sold Out' : 'Register Now')
      )
    )
  );
};

export default EventCard;